import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function contactPersonListReducer(state = initialState.contactPersons, action) {
    switch (action.type) {
        case types.LOAD_CONTACT_PERSONS_SUCCESS:
            return action.contactPersons;
            break;
        case types.CREATE_CONTACT_PERSON_SUCCESS:
            return [...state, Object.assign({}, action.contactPerson)];
            break;
        case  types.UPDATE_CONTACT_PERSON_SUCCESS:
            return [
                ...state.filter(contactPerson => contactPerson.id !== action.contactPerson.id),
                Object.assign({}, action.contactPerson)
            ];
            break;
        case types.GET_CONTACT_PERSON_SUCCESS:
            return [...state, Object.assign({}, action.contactPerson)];
        case types.CLONE_CONTACT_PERSON_SUCCESS:
            return [
                ...state.filter(contactPerson => contactPerson.id !== action.id),
                {...action.contactPerson}
            ];
        case types.DELETE_CONTACT_PERSON_SUCCESS:
            return state.filter(contactPerson => contactPerson.id !== action.id);
            break;
        default:
            return state;
            break;
    }
}



// WEBPACK FOOTER //
// ./web/src/reducers/contactPersonListReducer.js